import bakery_button from "../icons/button";
import React from 'react'
import color_palette_list from "../gb-helper/color_palette";
import IconPicker from './icon-picker/index';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import { __experimentalNumberControl as NumberControl } from '@wordpress/components';

const { registerBlockType, registerBlocksStyle } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    RichText } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, CheckboxControl,RangeControl, Dashicon, ToggleControl, ColorPalette, ColorIndicator,
    Card, CardBody, Button,   __experimentalGradientPicker, ColorPicker } = wp.components;



registerBlockType('blocksbakery/advbutton', {
    title: __('Button', 'blocks-bakery'),
    description: __(
        'This block is Adding Divider',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: bakery_button.bakery_button,
    keywords: [
        __('button', 'blocks-bakery'),
        __('Button', 'blocks-bakery'),
        __('Multiplebuttons', 'blocks-bakery'),
    ],
    supports: {
        html: false
    },
    "attributes": {

        //Background Color of Button

        "bb_button_content_wrapper_bg": {
            "type": "string",
            "default": "#61CE70"
        },
        "bb_button_content_wrapper_text_color": {
            "type": "string",
            "default": "#ffffff"
        },
        "icon_link": {
            "type": "string",
            "default": "#"
        },
        "open_tab_option": {
            "type": "boolean",
            "default": 'false'
        },
        "open_tab": {
            "type": "string",
            "default": 'null'
        },
        "rel_nofollow": {
            "type": "string",
            "default": 'null',
        },
        "nofollow": {
            "type": "boolean",
            "default": 'false',
        },
        "button_inline_block": {
            "type": "string",
            "default": "inline-block",
        },

        "button_padding_top": {
            "type": "number",
            "default": 12,
        },
        "button_padding_right": {
            "type": "number",
            "default": 24,
        },
        "button_padding_bottom": {
            "type": "number",
            "default": 12,
        },
        "button_padding_left": {
            "type": "number",
            "default": 24,
        },
        "icon_selector": {
            "type": "string",
            "default": ""
        },




        //for text box

        "bb_button_content_text": {
            "type": "string",
            "default": "Click Here"

        },
        "bb_button_content_text_change": {
            "type": "string",
            "default": "span"
        },
        "button_icon_position": {
            "type": "string",
            "default": "before",
        },


        //title 

        "title_family":{
            "type":"string",
            "default":"ABeeZee"
        },

        "adv_button_title_weight": {
            "type": "string",
            "default": "regular"

        },
        "px_em_vh_vw_title":{
            "type":"string",
            "default":"px"

        },
        "title_font_size":{
            "type":"number",
            "default":15
        },
        "adv_button_title_text_transform":{
            "type":"string",
            "default": 'none',
        },
        "adv_button_tile_font_style": {
            "type": "string",
            "default": "initial",
        },


        "img_border_radius_unit": {
            "type": "string",
            "default": "px"
        },

        "type_radius": {
            "type": "string",
            "default":""
        },

        //border_radius
        "border_left_radius": {
            "type": "string",
            "default": 4
        },
        "border_right_radius": {
            "type": "string",
            "default": 4
        },
        "border_top_radius": {
            "type": "string",
            "default": 4
        },
        "border_bottom_radius": {
            "type": "string",
            "default": 4
        },


        //border width
        "border_left_width": {
            "type": "string",
            "default": 0
        },
        "border_right_width": {
            "type": "string",
            "default": 0
        },
        "border_top_width": {
            "type": "string",
            "default": 0
        },
        "border_bottom_width": {
            "type": "string",
            "default": 0
        },
        "type_border_width": {
            "type": "string",
            "default":""
        },
        "border_width_color":{
            "type":"string",
            "default":"none"
        },
        "border_style":{
            "type":"string",
            "default":"none"
        },

        //title_shadow_blur

        "title_shadow_blur":{
            "type":"number",
            "default":0,
        }, 
        "text_shadow_horizental":{
            "type":"number",
            "default":0,
        },
        "text_shadow_vertical":{
            "type":"number",
            "default":0,
        },
        "text_shadow_clors":{
            "type":"string",
            "default":"",
        },


        //text

        "adv_button_text_decoration":{
            "type":"string",
            "default":"none",
        },
        "adv_btn_line_height_title":{
            "type":"number",
            "default":1.5
        },
        //box shadow properties 

        "button_box_shadow_hori":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_vert":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_blur":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_spred":{
            "type":"number",
            "default":0
        },
        "button_box_shadow_wrap_color":{
            "type":"string",
            "default":""
        },
        "desc_lh_controller":{
            "type":"string",
            "default":"em"
        },
        "order_pos":{  
            "type":"number",
            "default":0,
        },
        "adv_btn_letter_spacing":{
            "type":"number",
            "default":0,
        },
        "icon_margin_pos_left_right":{
            "type":"number",
            "default":5
        },

        //padding
        "button_padding_inn_top":{
            "type":"number",
            "default":12,
        },
        "button_padding_inn_right":{
            "type":"number",
            "default":24,
        },
        "button_padding_inn_bottom":{
            "type":"number",
            "default":12,
        },
        "button_padding_inn_left":{
            "type":"number",
            "default":24,
        },
        "padding_btn_px_em_per":{
            "type":"string",
            "default":"px"
        },
        "divider_text_transform":{
            "type":"string",
            "default":"none"
        },
        "button_bg_color_random":{
            "type":"string",
            "default":"default"
        },
        "button_bg_size_random":{
            "type":"string",
            "default":"extrasmall"
        },
        "text_align_wrapper":{
            "type":"string",
            "default":"left"
        },
        "box_shadow_inset_out":{
            "type":"string",
            "default":''
        },
        "box_shadow_outline_inset_outsit":{
            "type":"string",
            "default":"" 
        },
        "lineheight_units":{
            "type":"number",
        },

        //new attributes for before and after
        "icon_margin_pos_right":{
            "type":"number",
            "default":5,
        },
        "icon_margin_pos_left":{
            "type":"number",
            "default":5,
        },
        "gradient_bg": {
            "type": 'string',
            "default":"#61CE70"
        },




    },




    edit: (props) => {

        var index = font_family_detailed.findIndex(x => x.family === props.attributes.title_family);
       


        let styles = {

            bb_button_container: {
                width: "100%",
                textAlign: props.attributes.text_align_wrapper,
            },

            bb_button_content_wrapper: {

                backgroundColor: props.attributes.bb_button_content_wrapper_bg,
                background: props.attributes.gradient_bg,
                color: props.attributes.bb_button_content_wrapper_text_color,
                borderRadius: "3px",
                textAlign: "center",
                transition: "all .3s",
                fontSize: "15px",
                paddingTop: props.attributes.button_padding_inn_top + props.attributes.padding_btn_px_em_per,
                paddingRight: props.attributes.button_padding_inn_right + props.attributes.padding_btn_px_em_per,
                paddingBottom: props.attributes.button_padding_inn_bottom + props.attributes.padding_btn_px_em_per,
                paddingLeft: props.attributes.button_padding_inn_left + props.attributes.padding_btn_px_em_per,
                display: props.attributes.button_inline_block,
                borderRadius: props.attributes.border_top_radius +  props.attributes.img_border_radius_unit + " " +  props.attributes.border_right_radius +  props.attributes.img_border_radius_unit + " " +  props.attributes.border_bottom_radius +  props.attributes.img_border_radius_unit + " " +  props.attributes.border_left_radius +  props.attributes.img_border_radius_unit + " ",
                borderWidth: props.attributes.border_top_width+"px" + " "+ props.attributes.border_right_width+"px"+" "+ props.attributes.border_bottom_width+"px"+" "+ props.attributes.border_left_width+"px"
                ,borderColor: props.attributes.border_width_color,
                borderStyle: props.attributes.border_style,
                textDecoration:"none",
                boxShadow: props.attributes.button_box_shadow_hori + 'px' + ' ' + props.attributes.button_box_shadow_vert + 'px' + ' ' + props.attributes.button_box_shadow_blur + 'px' + ' ' + props.attributes.button_box_shadow_spred+ 'px' + ' ' + props.attributes.button_box_shadow_wrap_color +' ' + props.attributes.box_shadow_inset_out,
               
            },
            bb_icon_element: {


            },
            bb_icon_selector: {

            },
            bb_button_content_left: {
                marginRight: "5px",
                display: "flex",
                alignItems: "initial",
                fontSize:props.attributes.title_font_size+props.attributes.px_em_vh_vw_title,
            },
            bb_button_content:{
                display:"flex",
                order:props.attributes.order_pos,
                marginLeft:props.attributes.icon_margin_pos_left,
                marginRight:props.attributes.icon_margin_pos_right,
                alignItems:"center",
                lineHeight:props.attributes.adv_btn_line_height_title+props.attributes.desc_lh_controller,
         
               
            },
            bb_button_content_text_style:{
                fontFamily:props.attributes.title_family,
                fontWeight:props.attributes.adv_button_title_weight,
                // fontSize:props.attributes.title_font_size+props.attributes.px_em_vh_vw_title,
                textShadow: props.attributes.text_shadow_horizental + 'px' + ' ' + props.attributes.text_shadow_vertical + 'px' + ' ' + props.attributes.title_shadow_blur + 'px' + ' ' + props.attributes.text_shadow_clors,
               textTransform:props.attributes.divider_text_transform,
                fontStyle:props.attributes.adv_button_tile_font_style,
                textDecoration:props.attributes.adv_button_text_decoration,
                lineHeight:props.attributes.adv_btn_line_height_title+props.attributes.desc_lh_controller,
                letterSpacing:props.attributes.adv_btn_letter_spacing,
                margin:"0 auto"

            },
            bb_button_icon:{
                fontStyle:"normal",
                textShadow: props.attributes.text_shadow_horizental + 'px' + ' ' + props.attributes.text_shadow_vertical + 'px' + ' ' + props.attributes.title_shadow_blur + 'px' + ' ' + props.attributes.text_shadow_clors,
             
            }

        }


        //Button Background Random Function

        const button_bg_random = (new_val) => {
            if (new_val === "default") {
                var def = document.querySelector(".bb_button_content_wrapper");
                def.style.backgroundColor="#61CE70";
          
            }
            else if (new_val === "info") {
                var info = document.querySelector(".bb_button_content_wrapper");
                info.style.backgroundColor = "#5bc0de";
            }
            else if (new_val === "success") {
                var success = document.querySelector(".bb_button_content_wrapper");
                success.style.backgroundColor = "#5cb85c";
            }
            else if (new_val === "warning") {
                var warning = document.querySelector(".bb_button_content_wrapper");
                warning.style.backgroundColor = "#f0ad4e";
            }
            else if (new_val === "danger") {
                var danger = document.querySelector(".bb_button_content_wrapper");
                danger.style.backgroundColor = "#d9534f";
            }
        }

        //on off for the link....

        const open_link = () => {
            console.log("hello")
            var x = document.querySelector(".open_link");
            if (x.style.display === "none") {
                x.style.display = "block"
            }
            else {
                x.style.display = "none"
            }
        }


        //ALignment...
        const alignCenter = () => {
            props.setAttributes({ text_align_wrapper: 'center' })
            props.setAttributes({ button_inline_block: "inline-block" })
        }
        const alignLeft = () => {
            props.setAttributes({ text_align_wrapper: 'left' })
            props.setAttributes({ button_inline_block: "inline-block" })
        }
        const alignRight = () => {
            props.setAttributes({ text_align_wrapper: 'right' })
            props.setAttributes({ button_inline_block: "inline-block" })
        }

        const alignjustified = () => {
            console.log("full_width")

            props.setAttributes({ button_inline_block: "block" })
        }

        //For Responsive Devices

        const laptop = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
        }
        const tablet = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
        }
        const smartphone = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
        }


        //Sizes Functions

        const button_size_random = (new_val) => {
            if (new_val === "extrasmall") {
                props.setAttributes({ button_padding_inn_top: 10 })
                props.setAttributes({ button_padding_inn_bottom: 10 })
                props.setAttributes({ button_padding_inn_left: 20 })
                props.setAttributes({ button_padding_inn_right: 20 })
                props.setAttributes({title_font_size:13})
                props.setAttributes({border_top_radius:3})
                props.setAttributes({border_bottom_radius:3})
                props.setAttributes({border_left_radius:3})
                props.setAttributes({border_right_radius:3})


            }
            else if (new_val === "small") {
                props.setAttributes({ button_padding_inn_top: 12 })
                props.setAttributes({ button_padding_inn_bottom: 12 })
                props.setAttributes({ button_padding_inn_left: 24 })
                props.setAttributes({ button_padding_inn_right: 24 })
                props.setAttributes({title_font_size:15})
              
                props.setAttributes({border_top_radius:3})
                props.setAttributes({border_bottom_radius:3})
                props.setAttributes({border_left_radius:3})
                props.setAttributes({border_right_radius:3})
            }
            else if (new_val === "medium") {
                props.setAttributes({ button_padding_inn_top: 15 })
                props.setAttributes({ button_padding_inn_bottom: 15 })
                props.setAttributes({ button_padding_inn_left: 30 })
                props.setAttributes({ button_padding_inn_right: 30 })
                props.setAttributes({title_font_size:16})
                props.setAttributes({border_top_radius:4})
                props.setAttributes({border_top_radius:4})
                props.setAttributes({border_bottom_radius:4})
                props.setAttributes({border_left_radius:4})
                props.setAttributes({border_right_radius:4})
            }
            else if (new_val === "large") {
                props.setAttributes({ button_padding_inn_top: 20 })
                props.setAttributes({ button_padding_inn_bottom: 20 })
                props.setAttributes({ button_padding_inn_left: 40 })
                props.setAttributes({ button_padding_inn_right: 40 })
                props.setAttributes({title_font_size:18})
                props.setAttributes({border_top_radius:5})
                props.setAttributes({border_bottom_radius:5})
                props.setAttributes({border_left_radius:5})
                props.setAttributes({border_right_radius:5})
                
            }
            else if (new_val === "extralarge") {
                props.setAttributes({ button_padding_inn_top: 25 })
                props.setAttributes({ button_padding_inn_bottom: 25 })
                props.setAttributes({ button_padding_inn_left: 50 })
                props.setAttributes({ button_padding_inn_right: 50 })
                props.setAttributes({title_font_size:20})
                props.setAttributes({border_top_radius:6})
                props.setAttributes({border_bottom_radius:6})
                props.setAttributes({border_left_radius:6})
                props.setAttributes({border_right_radius:6})
            }
        }


        //functions for font sizes
        
        const px_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "underline";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ px_em_vh_vw_title: 'px' })
            props.setAttributes({title_units:200})
            console.log("px")
        }
        const em_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "underline";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ px_em_vh_vw_title: 'em' })
            props.setAttributes({title_units:10})
            console.log("em")
        }
        const rem_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "underline";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ px_em_vh_vw_title: 'rem', })
            props.setAttributes({title_units:10})
        }
        const vw_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "underline";

            props.setAttributes({ px_em_vh_vw_title: 'vw',})
            props.setAttributes({title_units:10})
        }


        //Line Height.......

        const title_px = () => {
            var x = document.getElementById("title_px");
            var y = document.getElementById("title_em");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({desc_lh_controller:"px"})
            props.setAttributes({lineheight_units:100})

        }
        const title_em = () => {
            var x = document.getElementById("title_px");
            var y = document.getElementById("title_em");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({desc_lh_controller:"em"})
            props.setAttributes({lineheight_units:10})
        }
 

        //for showing the text properties
        const show_remove_text_properties = () =>{
            var x = document.getElementById("card_data_btn");
            if(x.style.display==="none"){
                x.style.display="block";
            }
            else if(x.style.display==="block"){
                x.style.display="none"
            }
        }
        const show_remove_text_shadow_properties = () =>{
            var x = document.getElementById("card_text_shadow_btn");
            if(x.style.display==="none"){
                x.style.display="block";
            }
            else if(x.style.display==="block"){
                x.style.display="none"
            }
        }
       
        const  show_remove_box_shadow = () =>{
            var nn = document.getElementById("show_remove_box_shadow_txt");
            if(nn.style.display==="none"){
                nn.style.display="block";
            }
            else if(nn.style.display==="block"){
                nn.style.display="none"
            }
        }


        // for border radius 
        const ChangeForWidth = () => {

            if (props.attributes.isAllBorderWidth) {
                props.setAttributes({ isAllBorderWidth: false });
            } else {
                props.setAttributes({ isAllBorderWidth: true });
            }
        }
        
if (props.attributes.isAllBorderWidth === true) {
    console.log("true")
    if (props.attributes.type_border_width === "left") {
        props.setAttributes({
            border_right_width: props.attributes.border_left_width,
            border_left_width:  props.attributes.border_left_width,
            border_bottom_width:  props.attributes.border_left_width,
            border_top_width:  props.attributes.border_left_width,

        })

    } else if (props.attributes.type_border_width === "right") {
        props.setAttributes({
            border_right_width:  props.attributes.border_right_width,
            border_left_width:  props.attributes.border_right_width,
            border_bottom_width:  props.attributes.border_right_width,
            border_top_width:  props.attributes.border_right_width,

        })
    } else if (props.attributes.type_border_width === "top") {
        props.setAttributes({
            border_right_width:  props.attributes.border_top_width,
            border_left_width:  props.attributes.border_top_width,
            border_bottom_width: props.attributes.border_top_width,
            border_top_width:  props.attributes.border_top_width,

        })
    } else if (props.attributes.type_border_width === "bottom") {
        props.setAttributes({
            border_right_width: props.attributes.border_bottom_width,
            border_left_width:  props.attributes.border_bottom_rwidth,
            border_bottom_width:props.attributes.border_bottom_width,
            border_top_width:   props.attributes.border_bottom_width,

        })
    }
} else if (props.attributes.isAllBorderWidth === false) {
    console.log("false")
    props.setAttributes({
        border_top_width:    props.attributes.border_top_width,
        border_right_width:  props.attributes.border_right_width,
        border_left_width:   props.attributes.border_left_width,
        border_bottom_width: props.attributes.border_bottom_width,
    })
}


//end border radius

var img_radius_PX = document.getElementById("img_radius_px");
var img_radius_PER = document.getElementById("img_radius_per");
var img_radius_em = document.getElementById("img_radius_em");
const imgBorderPX = () => {
    img_radius_PX.style.textDecoration = "underline";
    img_radius_PER.style.textDecoration = "none";
    img_radius_em.style.textDecoration="none";
    setAttributes({ img_height: null, img_border_radius_unit: 'px' })
}
const imgBorderPER = () => {
    img_radius_PX.style.textDecoration = "none";
    img_radius_PER.style.textDecoration = "underline";
    img_radius_em.style.textDecoration="none";
    setAttributes({ img_height: null, img_border_radius_unit: '%' })
}
const imgBorderem = () => {
    img_radius_PX.style.textDecoration = "none";
    img_radius_PER.style.textDecoration = "none";
    img_radius_em.style.textDecoration="underline";
    setAttributes({ img_height: null, img_border_radius_unit: 'em' })
}



//start border-radis
const ChangeForRadius = () => {

    if (props.attributes.isAllRadius) {
        props.setAttributes({ isAllRadius: false });
    } else {
        props.setAttributes({ isAllRadius: true });
    }
}

if (props.attributes.isAllRadius === true) {
console.log("true")
if (props.attributes.type_radius === "left") {
props.setAttributes({
    border_right_radius: props.attributes.border_left_radius,
    border_left_radius:  props.attributes.border_left_radius,
    border_bottom_radius:  props.attributes.border_left_radius,
    border_top_radius:  props.attributes.border_left_radius,

})

} else if (props.attributes.type_radius === "right") {
props.setAttributes({
    border_right_radius:  props.attributes.border_right_radius,
    border_left_radius:  props.attributes.border_right_radius,
    border_bottom_radius:  props.attributes.border_right_radius,
    border_top_radius:  props.attributes.border_right_radius,

})
} else if (props.attributes.type_radius === "top") {
props.setAttributes({
    border_right_radius:  props.attributes.border_top_radius,
    border_left_radius:  props.attributes.border_top_radius,
    border_bottom_radius: props.attributes.border_top_radius,
    border_top_radius:  props.attributes.border_top_radius,

})
} else if (props.attributes.type_radius === "bottom") {
props.setAttributes({
    border_right_radius: props.attributes.border_bottom_radius,
    border_left_radius:  props.attributes.border_bottom_radius,
    border_bottom_radius:props.attributes.border_bottom_radius,
    border_top_radius:   props.attributes.border_bottom_radius,

})
}
} else if (props.attributes.isAllRadius === false) {
console.log("false")
props.setAttributes({
border_top_radius:    props.attributes.border_top_radius,
border_right_radius:  props.attributes.border_right_radius,
border_left_radius:   props.attributes.border_left_radius,
border_bottom_radius: props.attributes.border_bottom_radius,
})
}


const remove_box_shadow = () =>{
    props.setAttributes({button_box_shadow_hori:0})
    props.setAttributes({button_box_shadow_vert:0})
    props.setAttributes({button_box_shadow_blur:0})
    props.setAttributes({button_box_shadow_spred:0})
    props.setAttributes({button_box_shadow_wrap_color:''})
}

const remove_text_shaodw = () =>{
    props.setAttributes({text_shadow_horizental:0})
    props.setAttributes({text_shadow_vertical:0})
    props.setAttributes({title_shadow_blur:0})
    props.setAttributes({text_shadow_clors:''})
}

const button_pos = (new_val) =>{
    if(new_val==="before"){
        props.setAttributes({order_pos:0})
        var x = document.getElementById("icon_margin_right");
        var y = document.getElementById("icon_margin_left");
        props.setAttributes({icon_margin_pos_left:null})
        if(x.style.display==="block"){
            x.style.display="none"
            y.style.display="none"
        }
        else if(x.style.display==="none"){
            x.style.display="block"
            y.style.display="none"
        }

    }
    else if(new_val==="after"){
        props.setAttributes({order_pos:1})
        var x = document.getElementById("icon_margin_left");
        var y = document.getElementById("icon_margin_right");
        props.setAttributes({icon_margin_pos_right:null})
        if(x.style.display==="block"){
            x.style.display="none"
            y.style.display="none"
        }
        else if(x.style.display==="none"){
            x.style.display="block"
            y.style.display="none"
        }

    }
}


const paddingBtnpx = () =>{
    var x = document.getElementById("paddingBtnpx");
    var y = document.getElementById("paddingBtnper");
    var z = document.getElementById("paddingBtnem");
    x.style.textDecoration="underline";
    y.style.textDecoration="none";
    z.style.textDecoration="none";


    props.setAttributes({ padding_btn_px_em_per:'px' })
    props.attributes({padding_units:200})
}
const paddingBtnper = () =>{
    var x = document.getElementById("paddingBtnpx");
    var y = document.getElementById("paddingBtnper");
    var z = document.getElementById("paddingBtnem");
    x.style.textDecoration="none";
    y.style.textDecoration="underline";
    z.style.textDecoration="none";

    props.setAttributes({ padding_btn_px_em_per:'%' })
    props.attributes({padding_units:100})
}
const paddingBtnem = () =>{
    var x = document.getElementById("paddingBtnpx");
    var y = document.getElementById("paddingBtnper");
    var z = document.getElementById("paddingBtnem");
    x.style.textDecoration="none";
    y.style.textDecoration="none";
    z.style.textDecoration="underline";

    props.setAttributes({ padding_btn_px_em_per:'em' })
    props.attributes({padding_units:20})
}

const box_shadow_inset_outside=(new_val)=>{
if(new_val==='')
{
    console.log("outline");
    props.setAttributes({box_shadow_inset_out:''})
}
else if(new_val==="inset")
{
    console.log("inset");
    props.setAttributes({box_shadow_inset_out:"inset"})
}
}
        return [



            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__("Content")} initialOpen={false}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: "30%" }}><p>Type</p></div>
                            <div style={{ width: "70%" }}>
                        <SelectControl
                            options={[
                                { label: 'Default', value: 'default' },
                                { label: 'Info', value: 'info' },
                                { label: 'Success', value: 'success' },
                                { label: 'Warning', value: 'warning' },
                                { label: 'Danger', value: 'danger' },

                            ]}
                            value={props.attributes.button_bg_color_random}
                            onChange={(new_val) => {
                                props.setAttributes({ button_bg_color_random: new_val })
                                button_bg_random(new_val)
                            }}

                        />
                        </div>
                        </div>



                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: "30%" }}><p>Text</p></div>
                            <div style={{ width: "70%" }}>
                                <TextControl

                                    value={props.attributes.bb_button_content_text}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bb_button_content_text: new_val })
                                    }}
                                />

                            </div>
                        </div>


                        <p>Link</p>

                        <div style={{ display: "flex" }}>
                            <div style={{ width: "85%" }}>
                                <TextControl

                                    value={props.attributes.icon_link}
                                    onChange={(new_val) => {
                                        props.setAttributes({ icon_link: new_val })
                                    }}
                                />

                            </div>
                            <div className="" style={{ width: "15%", border: "1px solid black", height: "31px", textAlign: "center", lineHeight: "29px", cursor: "pointer" }}>
                                <i class="eicon-cog" aria-hidden="true" onClick={open_link}></i>

                            </div>
                        </div>




                        <div className="open_link" style={{ display: "none" }}>
                            <CheckboxControl
                                label="open in new window"
                                checked={props.attributes.open_tab_option}
                                onChange={(value) => {
                                    if (value === false) {
                                        props.setAttributes({ open_tab: "_self", open_tab_option: false })
                                    } else {
                                        props.setAttributes({ open_tab: "_blank", open_tab_option: true })
                                    }
                                }
                                }
                            />
                            <CheckboxControl
                                label="Add nofollow"
                                checked={props.attributes.nofollow}
                                onChange={(value) => {
                                    if (value === false) {
                                        props.setAttributes({ rel_nofollow: null, nofollow: false })
                                    } else {
                                        props.setAttributes({ rel_nofollow: "nofollow", nofollow: true })
                                    }
                                }
                                }
                            />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Alignment</p>

                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignLeft} icon='editor-alignleft' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignCenter} icon='editor-aligncenter' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignRight} icon='editor-alignright' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={alignjustified} icon='editor-justify' />
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>


                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: "30%" }}>Size</div>

                            <div style={{ width: "70%" }}>


                                <SelectControl
                                    options={[
                                        { label: 'Extra Small', value: 'extrasmall' },
                                        { label: 'Small', value: 'small' },
                                        { label: 'Medium', value: 'medium' },
                                        { label: 'Large', value: 'large' },
                                        { label: 'Extra Large', value: 'extralarge' },

                                    ]}
                                    value={props.attributes.button_bg_size_random}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_bg_size_random: new_val })
                                        button_size_random(new_val)
                                    }}

                                />
                            </div>
                        </div>


                        {/* For Icon Upload  */}

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: "30%" }}>Position</div>

                            <div style={{ width: "70%" }}>


                                <SelectControl
                                    options={[
                                        { label: 'Before', value: 'before' },
                                        { label: 'After', value: 'after' },
                                     


                                    ]}
                                    value={props.attributes.button_icon_position}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_icon_position: new_val })
                                      
                                        button_pos(new_val)

                                    }}

                                />
                            </div>
                        </div>




                        <IconPicker
                            allowReset={false}
                            value={props.attributes.icon_selector}

                            onChange={(newIcon) => props.setAttributes({ icon_selector: newIcon })}
                        />

                        <br />
                        
                        <div id="icon_margin_left" style={{display:"none"}}>
                        <RangeControl
                        label="Spacing Left"
                            min={0}
                            max={50}
                            value={props.attributes.icon_margin_pos_left}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_margin_pos_left: new_val })
                                // hexConverter(new_val)
                            }}
                        />
                        </div>

                        <div id="icon_margin_right">
                        <RangeControl
                          label="Spacing Right"
                            min={0}
                            max={50}
                            value={props.attributes.icon_margin_pos_right}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_margin_pos_right: new_val })
                                // hexConverter(new_val)
                            }}
                        />
                        </div>


                        <br />



                    </PanelBody>
                    <PanelBody title={__("Style")} initialOpen={false}>
                        <div style={{ display: "flex", alignItems: "center",marginTop:"12px" }}>

                            {/* Typography  */}
                            <div style={{ width: "84%",fontWeight:"14px",marginTop:"-5px",fontWeight:"bold" }}>Size</div>

                            <div style={{ width: "40%" }}>

                                <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}}><i class="fas fa-globe"></i></Button>
                                <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}} onClick={show_remove_text_properties}><i class="fas fa-pencil-alt"></i></Button>


                            </div>
                        </div>

                        {/* Card Data  */}

                        <Card id="card_data_btn" style={{"marginTop":"9px","boxShadow":"0 2px 15px rgb(0 0 0 / 30%)","display":"none"}}>
                            <CardBody style={{"padding":"16px 8px"}} >

                      
                        <div style={{ display: "flex", alignItems: "center" }}>

                            {/* Typography  */}
                            <div style={{ width: "70%" }}>Family</div>

                            <div style={{ width: "30%" }}>
                                <SelectControl

                                    options={all_font_families}
                                    onChange={(new_val) => {
                                        props.setAttributes({ title_family: new_val })
                                    }}
                                    value={props.attributes.title_family}

                                />
                            </div>
                        </div>


                                    {/* fontsize  */}

                                    <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="px_case" onClick={px_case} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="em_case" onClick={em_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                                <Button id="rem_case" onClick={rem_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                                <Button id="vw_case" onClick={vw_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                            </div>
                        </PanelRow>


                      
                        <RangeControl
                            min={0}
                            max={props.attributes.title_units}
                            value={props.attributes.title_font_size}
                            step={1}
                            onChange={(new_val) => {
                                props.setAttributes({ title_font_size: new_val })
                                // hexConverter(new_val)
                            }}
                        />


                                    {/* end of fontsize  */}

                                    {/* start typography etc  */}


                                    <SelectControl
                            label="Text Transform"
                            options={[
                                { label: 'default', value: 'none' },
                                { label: 'Uppercase', value: 'uppercase' },
                                { label: 'Lowercase', value: 'lowercase' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Normal', value: 'normal' },

                            ]}
                            value={props.attributes.divider_text_transform}
                            onChange={(new_val) => {
                                props.setAttributes({ divider_text_transform: new_val })
                            }}
                        />
                        <SelectControl
                            label="Style"
                            options={[
                                { label: 'Default', value: 'initial' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Italic', value: 'italic' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Oblique', value: 'oblique' },

                            ]}
                            value={props.attributes.adv_button_tile_font_style}
                            onChange={(new_val) => {
                                props.setAttributes({ adv_button_tile_font_style: new_val })
                            }}
                        />



                        <SelectControl
                            label="Decoration"
                            options={[
                                { label: 'Default', value: 'none' },
                                { label: 'Underline', value: 'underline' },
                                { label: 'line Through', value: 'line-through' },
                                { label: 'Line Trough and Underline', value: 'underline line-through' },
                                { label: 'overline', value: 'overline' },


                            ]}
                            value={props.attributes.adv_button_text_decoration}
                            onChange={(new_val) => {
                                props.setAttributes({ adv_button_text_decoration: new_val })
                            }}
                        />


                                    {/* End  */}

                       <div style={{ display: "flex", alignItems: "center" }}>

                            {/* Typography  */}
                            <div style={{ width: "70%" }}>Weight</div>

                            <div style={{ width: "30%" }}>
                             <SelectControl
                        
                                options={
                                    [
                                        { label: '100', value: 100 },
                                        { label: '200', value: 200 },
                                        { label: '300', value: 300 },
                                        { label: '400', value: 400 },
                                        { label: '500', value: 500 },
                                        { label: '600', value: 600 },
                                        { label: '700', value: 700 },
                                        { label: '800', value: 800 },
                                        { label: '900', value: 900 },
                                        { label: 'Default', value: '' },
                                        { label: 'Normal', value: 'normal' },
                                        { label: 'Bold', value: 'bold' }
                                    ]
                                }
                                onChange={(new_val) => {
                                    props.setAttributes({ adv_button_title_weight: new_val })
                                }}
                                value={props.attributes.adv_button_title_weight}
                            />

                            </div>
                            </div>

                            {/* For Line Height  */}
                            <div style={{ display: 'flex', justifyContent: 'space-between',alignItems:"center" }}>
                          
                            <div>
                            <span style={{marginRight:"10px"}}>Line Height</span>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        
                            <div>
                                <Button id="title_px" onClick={title_px} style={{  padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="title_em" onClick={title_em} style={{ textDecoration: "underline",padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            </div>
                            </div>

                            
                            {/* Text Shadow */}
                        




                            {/* Letter Spacing  */}

                            <RangeControl
                            label="Line Height"
                            min={0}
                            max={props.attributes.lineheight_units}
                            step={1}
                            initialPosition={0}
                            value={props.attributes.adv_btn_line_height_title}
                            onChange={(new_val) => {
                                props.setAttributes({ adv_btn_line_height_title: new_val })
                            }}
                        />

                           <RangeControl
                            label="Letter Spacing"
                            min={-5}
                            max={10}
                            step={1}
                            initialPosition={0}
                            value={props.attributes.adv_btn_letter_spacing}
                            onChange={(new_val) => {
                                props.setAttributes({ adv_btn_letter_spacing: new_val })
                                
                            }}
                        />
                        </CardBody>
                        </Card>

                        {/* End of the Card  */}
                        <PanelRow style={{marginTop:"9px",marginBottom:"9px"}}>
                            <p>Text Shadow</p>

                            <div>
                            <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}} onClick={remove_text_shaodw}><i class="fas fa-undo"></i></Button>
                            <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}} onClick={show_remove_text_shadow_properties}><i class="fas fa-pencil-alt"></i></Button>
                       </div>
                        </PanelRow>




                        {/* start card of text shadow */}
                        <Card id="card_text_shadow_btn" style={{"marginTop":"9px","boxShadow":"0 2px 15px rgb(0 0 0 / 30%)","display":"none"}}>
                            <CardBody style={{"padding":"16px 8px"}} >

                            <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={100}
                                    step={1}
                                    initialPosition={10}
                                    value={props.attributes.title_shadow_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ title_shadow_blur: new_val })
                                        console.log("Blur")
                                    }}
                                />
                                <RangeControl
                                    label="Horizontal"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.text_shadow_horizental}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_horizental: new_val })
                                        console.log("horitzental")
                                    }}
                                />

                                <RangeControl
                                    label="Vertical"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.text_shadow_vertical}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_vertical: new_val })
                                        console.log("vertical")
                                    }}
                                />

                                <p>Color<span> <ColorIndicator
                                    style={{ backgroundColor: props.attributes.text_shadow_clors }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_clors: new_val })

                                    }}
                                    value={props.attributes.text_shadow_clors}
                                />
                      
                      </CardBody>
                      </Card>
                        {/* End of the Typography */}


                        <p>Text Color<span>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.bb_button_content_wrapper_text_color }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            clearable={false}
                            onChange={(new_val) => {
                                props.setAttributes({ bb_button_content_wrapper_text_color: new_val })
                            }}
                            value={props.attributes.bb_button_content_wrapper_text_color}
                        />
                        <hr />
                        <p>Background Color<span> 
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.bb_button_content_wrapper_bg }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            clearable={false}
                            onChange={(new_val) => {
                                props.setAttributes({ bb_button_content_wrapper_bg: new_val })
                                props.setAttributes({gradient_bg:null})
                            }}
                            value={props.attributes.bb_button_content_wrapper_bg}
                        />

                          <__experimentalGradientPicker
                                value={props.attributes.gradient_bg}
                                onChange={(new_val) => {
                                    props.setAttributes({ gradient_bg: new_val })
                                    props.setAttributes({ bb_button_content_wrapper_bg: gradient_bg })
                                  
                                }}
                            />
                        
                           <div style={{ display: "flex", alignItems: "center",marginTop:"24px",marginBottom:"10px" }}>

                            {/* Typography  */}
                            <div style={{ width: "84%",fontWeight:"14px",marginTop:"-5px",fontWeight:"bold" }}>Border Style</div>

                            <div style={{ width: "40%" }}>

                            <SelectControl
                          
                            options={[
                                { label: 'None', value: 'none' },
                                { label: 'Solid', value: 'solid' },
                                { label: 'Dotted', value: 'dotted' },
                                { label: 'Dashed', value: 'dashed' },
                                { label: 'Double', value: 'double' },
                                { label: 'Inset', value: 'inset' },

                            ]}
                            value={props.attributes.border_style}
                            onChange={(new_val) => {
                                props.setAttributes({ border_style: new_val })
                            }}
                        />

                            </div>
                        </div>



                        {/* border width  */}

                        <div style={{marginTop:"30px",marginBottom:"30px"}}>
                            <span style={{marginRight:"10px"}}>Border Width</span>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>

                            <div>

                            <div style={{ display: 'flex', fontSize: '10px' }}>
                        <NumberControl
                            label="TOP"
                            onChange={e => props.setAttributes({ border_top_width: e, type_border_width: "top" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_top_width}
                        />
                        <NumberControl
                            label="RIGHT"
                            onChange={e => props.setAttributes({ border_right_width: e, type_border_width: "right" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_right_width}
                        />
                        <NumberControl
                            label="BOTTOM"
                            onChange={e => props.setAttributes({ border_bottom_width: e, type_border_width: "bottom" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_bottom_width}
                        />
                        <NumberControl
                            label="LEFT"
                            onChange={e => props.setAttributes({ border_left_width: e, type_border_width: "left" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_left_width}
                        />
                        <Dashicon onClick={ChangeForWidth} style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px', marginLeft: '10px',
                            width: '150px', height: '30px', border: '1px solid darkslategray'
                        }} icon="admin-links" />
                    </div>

                                </div>
                       

                    {/* start of border radius  */}
                    <PanelRow>
                        <p>
                            <span> Border Radius </span>
                            <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                        </p>
                        <div>
                            <Button id="img_radius_px" onClick={imgBorderPX} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="img_radius_per" onClick={imgBorderPER} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>%</Button>
                            <Button id="img_radius_em" onClick={imgBorderem} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>EM</Button>
                        </div>
                    </PanelRow>
                    <div style={{ display: 'flex', fontSize: '10px' }}>
                        <NumberControl
                            label="TOP"
                            onChange={e => props.setAttributes({ border_top_radius: e, type_radius: "top" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_top_radius}
                        />
                        <NumberControl
                            label="RIGHT"
                            onChange={e => props.setAttributes({ border_right_radius: e, type_radius: "right" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_right_radius}
                        />
                        <NumberControl
                            label="BOTTOM"
                            onChange={e => props.setAttributes({ border_bottom_radius: e, type_radius: "bottom" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_bottom_radius}
                        />
                        <NumberControl
                            label="LEFT"
                            onChange={e => props.setAttributes({ border_left_radius: e, type_radius: "left" })}
                            isDragEnabled
                            isShiftStepEnabled
                            shiftStep={1}
                            step={1}
                            value={props.attributes.border_left_radius}
                        />
                        <Dashicon onClick={ChangeForRadius} style={{
                            display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '15px', marginLeft: '10px',
                            width: '150px', height: '30px', border: '1px solid darkslategray'
                        }} icon="admin-links" />
                    </div>
                        <hr/>
                    <p>Border Color<span> <ColorIndicator
                                    style={{ backgroundColor: props.attributes.border_width_color }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    clearable={false}
                                    onChange={(new_val) => {
                                        props.setAttributes({ border_width_color: new_val })

                                    }}
                                    value={props.attributes.border_width_color}
                                />
                    <hr/>

                    <PanelRow style={{marginTop:"9px",marginBottom:"9px"}}>
                            <p>Box Shadow</p>

                            <div>
                            <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}} onClick={remove_box_shadow}><i class="fas fa-undo"></i></Button>
                            <Button style={{"border":"1px solid","width":"40px","height":"30px","textAlign":"center","margin":"0px","lineHeight":"10px"}} onClick={show_remove_box_shadow}><i class="fas fa-pencil-alt"></i></Button>
                            </div>
                        </PanelRow>

                             {/* start card of text shadow */}
                             <Card id="show_remove_box_shadow_txt" style={{"marginTop":"9px","boxShadow":"0 2px 15px rgb(0 0 0 / 30%)","display":"none"}}>
                            <CardBody style={{"padding":"16px 8px"}} >
                            <RangeControl
                                    label="Horizontal"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.button_box_shadow_hori}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_box_shadow_hori: new_val })
                                     
                                    }}
                                />
                                  <RangeControl
                                    label="Vertical"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.button_box_shadow_vert}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_box_shadow_vert: new_val })
                                
                                    }}
                                />
                            <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={100}
                                    step={1}
                                    initialPosition={10}
                                    value={props.attributes.button_box_shadow_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_box_shadow_blur: new_val })
                                       
                                    }}
                                />
                             

                                <RangeControl
                                    label="Spread"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.button_box_shadow_spred}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_box_shadow_spred: new_val })
                                      
                                    }}
                                />

                                <p>Box Shadow Color<span> <ColorIndicator
                                    style={{ backgroundColor: props.attributes.text_shadow_clors }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_box_shadow_wrap_color: new_val })

                                    }}
                                    value={props.attributes.button_box_shadow_wrap_color}
                                />
                      

  
                           <div style={{ display: "flex", alignItems: "center",marginTop:"24px",marginBottom:"10px" }}>

                            {/* Typography  */}
                            <div style={{ width: "84%",fontWeight:"14px",marginTop:"-5px",fontWeight:"bold" }}>Box Shadow</div>

                            <div style={{ width: "40%" }}>

                            <SelectControl
                          
                            options={[
                                { label: 'Outline', value: '' },
                                { label: 'Inset', value: 'inset' },
                              

                            ]}
                            value={props.attributes.box_shadow_inset_out}
                            onChange={(new_val) => {
                                props.setAttributes({ box_shadow_inset_out: new_val })
                                box_shadow_inset_outside(new_val);
                            }}
                        />

                            </div>
                        </div>
                      
                      </CardBody>
                      </Card>

                      <PanelRow>
                        <p>
                            <span> Padding </span>
                            <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                            <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                        </p>
                        <div>
                            <Button id="paddingBtnpx" onClick={paddingBtnpx} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                            <Button id="paddingBtnper" onClick={paddingBtnper} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>%</Button>
                            <Button id="paddingBtnem" onClick={paddingBtnem} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>EM</Button>
                        </div>
                    </PanelRow>

                                    <RangeControl
                                    label="Padding Top"
                                    min={0}
                                    max={props.attributes.padding_units}
                                    step={1}
                                    initialPosition={12}
                                    value={props.attributes.button_padding_inn_top}
                                    onChange={(new_val) => {
                                        props.setAttributes({ button_padding_inn_top: new_val })
                                      
                                    }}
                                />         
                                <RangeControl
                                label="Padding Right"
                                min={0}
                                max={props.attributes.padding_units}
                                step={1}
                                initialPosition={24}
                                value={props.attributes.button_padding_inn_right}
                                onChange={(new_val) => {
                                    props.setAttributes({ button_padding_inn_right: new_val })
                                  
                                }}
                            />

                                <RangeControl
                                label="Padding Bottom"
                                min={0}
                                max={props.attributes.padding_units}
                                step={1}
                                initialPosition={12}
                                value={props.attributes.button_padding_inn_bottom}
                                onChange={(new_val) => {
                                    props.setAttributes({ button_padding_inn_bottom: new_val })
                                  
                                }}
                                />

                                <RangeControl
                                label="Padding Left"
                                min={0}
                                max={props.attributes.padding_units}
                                step={1}
                                initialPosition={24}
                                value={props.attributes.button_padding_inn_left}
                                onChange={(new_val) => {
                                    props.setAttributes({ button_padding_inn_left: new_val })
                                  
                                }}
                                />

                    </PanelBody>


                </InspectorControls>
                <div className="bb_button_container" style={styles.bb_button_container} >
                    <div className="bb_button_wrapper" >

                        <a className="bb_button_content_wrapper"  href={props.attributes.icon_link} target={props.attributes.open_tab} rel={props.attributes.rel_nofollow} style={styles.bb_button_content_wrapper}>
                            <span className="bb_button_content_inner_wrapper" style={styles.bb_button_content_left}>

                                <span className="bb_button_content"
                                style={styles.bb_button_content}   
                                >

                                    <i className={props.attributes.icon_selector} style={styles.bb_button_icon}></i>
                                </span>
                                <RichText
                                    className="bb_button_content_text"
                                    tagName={props.attributes.bb_button_content_text_change}
                                    value={props.attributes.bb_button_content_text}
                                    style={styles.bb_button_content_text_style}
                                    onChange={(new_val) => {
                                        props.setAttributes({ bb_button_content_text: new_val })
                                    }}



                                />


                            </span>
                        </a>

                    </div>
                </div>

            </React.Fragment>
        ]
    },

    save: (props) => {
        return (null)
    }
});


